/**
 * Created by Megi on 03/07/2017.
 */
define(function (require) {
    "use strict";

    var BaseFeatureController = require("personalization-controllers/BaseFeatureController");
    var IFrameIntegrationWidgetOrganizeController = require("personalization-web-agent-controllers/IFrameIntegrationWidgetOrganizeController");
    var IFrameIntegrationWidgetEditController = require("personalization-web-agent-controllers/IFrameIntegrationWidgetEditController");

    var FEATURES_TO_EDIT = {
        EDIT_WIDGET: "editWidget",
        ORGANIZE_WIDGETS: "organizeWidgets"
    };

    var FEATURES_CONTROLLER_MAP = {};
    FEATURES_CONTROLLER_MAP[FEATURES_TO_EDIT.EDIT_WIDGET] = IFrameIntegrationWidgetEditController;
    FEATURES_CONTROLLER_MAP[FEATURES_TO_EDIT.ORGANIZE_WIDGETS] = IFrameIntegrationWidgetOrganizeController;


    var WidgetListEditController = {};

    LE.module("LEPersonalization", function (LEPersonalization, LE, Backbone, Marionette, $, _) {

        WidgetListEditController = BaseFeatureController.extend({
            initialize: function(options) {
                this._initialize(options);
            },


            getEditView: function() {
                return this._getEditView();
            },


            _initialize: function (options) {
                LEPersonalization.logger.info("initializing", "WidgetListEditController:_initialize");

                this.controllerOptions = options;
                this.controller = new FEATURES_CONTROLLER_MAP[options.controllerOptions.featureToEdit](this.controllerOptions);
            },

            _getEditView: function () {
                return this.controller.getEditView();
            }
        });
    });

    WidgetListEditController.FEATURES_TO_EDIT = FEATURES_TO_EDIT;

    return WidgetListEditController;

});
